module.exports = __webpack_public_path__ + "static/authenticity-2-db3d1a7b4d197a98d90e4a21f6b8a59e.jpg";